<template>
  <narrow-container>
    <h1 class="headline-secondary text--center">
      {{ $i18n.t('TOPUP_VOUCHER_SUCCESS.HEADER') }}
    </h1>
    <br>
    <p class="text--center">
      {{ $i18n.t('TOPUP_VOUCHER_SUCCESS.P1') }}
    </p>
    <p class="text--center">
      {{ $i18n.t('TOPUP_VOUCHER_SUCCESS.P2') }}
    </p>
    <div class="block--centered">
      <router-link
        class="button button--blue button--centered"
        :to="{name:'topUp'}"
      >
        {{ $i18n.t('TOPUP_VOUCHER_SUCCESS.ATU_BUTTON') }}
      </router-link>
    </div>
    <br>
    <p class="text--center">
      {{ $i18n.t('TOPUP_VOUCHER_SUCCESS.P3') }}
    </p>
  </narrow-container>
</template>

<script>
  export default {
    name: "TopupVoucherSuccess",
    components: {}
  }
</script>

<style scoped lang="scss">
  .button--centered {
    padding-right: 62px;
    padding-left: 62px;
  }
  .block--centered {
    text-align: center;
  }
</style>
